import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const usePaymentCalls = () => {
  const { get } = requests

  const getPayments = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('pagos/tabla_pagos', config)
          .then((response) => {
            return resolve(response)
          })
          .catch(({ response }) => {
            return reject(response)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getPayments,
  }
}
